import PropTypes from 'prop-types';

import {
  DescriptionListDescription,
  DescriptionListTerm,
  Button,
  TextInputGroup,
  TextInputGroupUtilities,
  TextInputGroupMain,
  Flex,
  FlexItem
} from '@patternfly/react-core';
import _ from 'lodash';
import React, { Fragment, useCallback, useState } from 'react';
import { useTranslation } from '../../localization/useTranslation';
import Icons from 'components/Common/Icons';
import useBoolean from 'utils/hooks/useBoolean';


const InlineEdit = ({ onChange, cancelUpdate, value }) => {
  const [edit, setEdit] = useState(value);
  const _onChange = useCallback((unusedEvent, newValue) => {
    setEdit(newValue);
    onChange(newValue);
  }, [onChange]);

  return (
    <TextInputGroup>
      <TextInputGroupMain value={edit} onChange={_onChange} />
      <TextInputGroupUtilities>
        <Button variant="plain" onClick={() => cancelUpdate()}>
          <Icons.Close/>
        </Button>
      </TextInputGroupUtilities>
    </TextInputGroup>
  );
};

const InlineEditDescription = ({ label, value, onChange }) => {
  const T = useTranslation();
  const [isEditing, , , toggleEditing] = useBoolean(false);

  const _onChange = useCallback((newValue) => {
    if (!_.isEqual(newValue, value)) {
      onChange?.(newValue);
    }
  }, [onChange, value]);

  const cancelUpdate = useCallback(() => {
    toggleEditing();
  }, [toggleEditing]);

  return (
    <Fragment>
      <DescriptionListTerm>{ T.localize(label) }</DescriptionListTerm>
      { isEditing && <InlineEdit onChange={_onChange} cancelUpdate={cancelUpdate} value={value}/> }
      { !isEditing && <DescriptionListDescription>
        <div onClick={() => toggleEditing()} style={{ cursor: 'pointer' }}>
          <Flex>
            <FlexItem>
              { value }
            </FlexItem>
            <FlexItem>
              <Icons.Edit/>
            </FlexItem>
          </Flex>
        </div>
      </DescriptionListDescription>
      }
    </Fragment>

  );
};

export default InlineEditDescription;

InlineEditDescription.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func
};
